import routes from './auth-routes';
import store from './auth-store';
import authGuardMixin from './guards/auth-guard-mixin';
import unauthGuardMixin from './guards/unauth-guard-mixin';
import emailAlreadyVerifiedGuardMixin from './guards/email-already-verified-guard-mixin';
import notEmptyPermissionsGuardMixin from './guards/not-empty-permissions-guard-mixin';
import roleGuardMixin from './guards/role-guard-mixin';

const mixins = [
  authGuardMixin,
  unauthGuardMixin,
  emailAlreadyVerifiedGuardMixin,
  notEmptyPermissionsGuardMixin,
  roleGuardMixin
];

export default {
  routes,
  store,
  mixins
};



// WEBPACK FOOTER //
// ./src/auth/auth-module.js